"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const jsx_runtime_1 = require("react/jsx-runtime");
const SvgSideMenuIcon = props => (0, jsx_runtime_1.jsx)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 13.12,
  height: 14.29,
  ...props,
  children: (0, jsx_runtime_1.jsxs)("g", {
    fill: "currentColor",
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M1.22 2.79h11.9v1.5H1.22zm5 5h6.9v1.5h-6.9zm0 5h6.9v1.5h-6.9z"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M0 3.54L3.54 0 4.6 1.06 1.06 4.6z"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M1.06 2.47L4.6 6.01 3.54 7.07 0 3.54z"
    })]
  })
});
exports.default = SvgSideMenuIcon;